import React, { useState, useRef, useEffect } from 'react';
import { Spinner } from '../../components/ui';
import { errMsg } from '../../utils/format';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function AIPanel() {
  const { user } = useAuth();
  const [messages, setMessages] = useState([
    { role:'assistant', content:'Hello! I\'m your StockForge AI assistant. I can help you query inventory data, generate reports, and make configuration changes. What can I help you with?' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior:'smooth' }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading) return;
    const userMsg = { role:'user', content: input };
    const newMsgs = [...messages, userMsg];
    setMessages(newMsgs);
    setInput('');
    setLoading(true);
    try {
      const { data } = await api.post('/api/ai/chat', { messages: newMsgs.filter(m => m.role !== 'system') });
      setMessages(m => [...m, { role:'assistant', content: data.reply }]);
    } catch (err) {
      setMessages(m => [...m, { role:'assistant', content: `Error: ${errMsg(err)}` }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'calc(100vh - 120px)' }}>
      <div className="page-header"><h1>AI Admin Panel</h1></div>
      <div style={{ flex:1, overflowY:'auto', display:'flex', flexDirection:'column', gap:12, marginBottom:12 }}>
        {messages.map((m, i) => (
          <div key={i} style={{ display:'flex', justifyContent: m.role==='user'?'flex-end':'flex-start' }}>
            <div style={{
              maxWidth:'70%', padding:'10px 14px', borderRadius:12,
              background: m.role==='user' ? 'var(--blue)' : 'var(--card-bg)',
              color: m.role==='user' ? '#fff' : 'var(--text-primary)',
              border: m.role==='user' ? 'none' : '0.5px solid var(--card-border)',
              fontSize:13, lineHeight:1.6, whiteSpace:'pre-wrap',
            }}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && <div style={{ display:'flex', justifyContent:'flex-start' }}><div style={{ padding:'10px 14px', background:'var(--card-bg)', border:'0.5px solid var(--card-border)', borderRadius:12 }}><Spinner text="Thinking…" /></div></div>}
        <div ref={bottomRef} />
      </div>
      <form onSubmit={send} style={{ display:'flex', gap:8 }}>
        <input style={{ flex:1 }} placeholder="Ask anything about your inventory…" value={input}
          onChange={e => setInput(e.target.value)} disabled={loading} />
        <button className="btn btn-primary" type="submit" disabled={!input.trim() || loading}>
          <i className="ti ti-send" />
        </button>
      </form>
    </div>
  );
}
